import { ReactComponent } from './number-4-xs.svg';
export const Number4IconXs = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=number-4-xs.js.map